import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Paper,
  SxProps,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Theme,
  Typography,
  useTheme,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import React from "react";

type Props = {
  title: string;
  tableDefinition: { title: string; value: React.ReactNode }[];
  ariaLabel: string;
  tableSx?: SxProps<Theme>;
  footer?: React.ReactNode;
};

export function TableSection({ title, ariaLabel, tableDefinition, tableSx, footer }: Props) {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  return (
    <Accordion defaultExpanded>
      <AccordionSummary
        expandIcon={<KeyboardArrowDownIcon />}
        aria-controls="information-panel-content"
        id="information-panel"
      >
        <Typography variant="h3">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <TableContainer component={Paper}>
          <Table sx={{ width: "100%", ...tableSx }} size="small" aria-label={ariaLabel}>
            <TableBody>
              {tableDefinition.map((row, index) => (
                <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }} key={index}>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ background: isDarkMode ? theme.palette.grey[200] : "#d5d2d2", whiteSpace: "nowrap" }}
                  >
                    {row.title}
                  </TableCell>
                  <TableCell align="right">{row.value}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {footer && <Box sx={{ padding: 1 }}>{footer}</Box>}
        </TableContainer>
      </AccordionDetails>
    </Accordion>
  );
}
